import React from "react";
import { makeStyles } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import CartIcon from "@material-ui/icons/ShoppingCart";
import Typography from "@material-ui/core/Typography";
import HelpIcon from "@material-ui/icons/HelpOutline";
import { Context as CartContext } from "../../context/cart.context";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    outline: "none",
    borderRadius: 8,
    width: 560,
    maxWidth: 560,
  },
  table: {
    minWidth: 650,
  },
}));

const numberWithCommas = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const PaymentOptions = (props) => {
  const { state, addToCart, removeFromCart } = React.useContext(CartContext);
  const classes = useStyles();
  const cartItem = props.cartItem;
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={props.modalOpen}
      onClose={() => props.setModalOpen(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.modalOpen}>
        <div className={classes.paper}> 

            <h3
              style={{
            		display: 'flex',
                flexDirection: 'row',
                marginBottom: 25,
              }}
            >
              Addtional Payment Options Available.
            </h3>

            <div
              style={{
                // display: 'flex',
                // flexDirection: 'row',
              }}
            >
            {cartItem.paymentOptions.map((po, index) => {	
                return <>
                      <Button
                          variant="contained"
                          color="primary"
                          style={{
                            color: "white",
                            width: "47%",
                            backgroundColor:"#009ade",
                            borderRadius: 6,
                            marginRight: 10,
                            marginBottom: 25,
                            fontSize:13.5,
                            // padding:10,
                            // flexDirection: 'column'
                          }}
                          startIcon={ <CartIcon />}
                          onClick={() => {
                              cartItem.customPaymentOption = Number(po.amount);
                              addToCart(cartItem);
                              props.setModalOpen(false)
                          }}
                      >
                          {po.name + ': '} ${numberWithCommas(Number(po.amount).toFixed(2))}
                      </Button>
                </>;
            })}
            </div>

                      

          <div style={styles.bottomBar}>
            <Button
              variant="contained"
              onClick={() => props.setModalOpen(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

const styles = {
  bottomBar: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
    borderTop: "1px solid #ddd",
    paddingTop: 25,
  },
  topBar: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid #ddd",
    marginBottom: 25,
  },
};

export default PaymentOptions;
